// extracted by mini-css-extract-plugin
module.exports = {"success":"Wait_success__w4kcs","failure":"Wait_failure__23e70","hash":"Wait_hash__3AeVS","feedback":"Wait_feedback__2E_8C"};